import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { AcceptCookieService } from './accept-cookie.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-accept-cookie',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accept-cookie.component.html',
  styleUrl: './accept-cookie.component.scss',
})
export class AcceptCookieComponent implements OnInit {
  showBanner = false;
  hidingBanner = false;
  assetBaseUrl: string = '';

  constructor(
    private acceptCookieService: AcceptCookieService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.assetBaseUrl = environment.assetBaseUrl;
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.showBanner = !this.acceptCookieService.hasAccepted();
    }
  }

  onAccept() {
    this.hidingBanner = true;

    setTimeout(() => {
      this.acceptCookieService.accept();
      this.showBanner = false;
      this.hidingBanner = false;
    }, 350);
  }
}
